import type { ReactNode } from 'react';
import { grantsContent } from '../api/client';
import { useMe } from '../api/queries';
import type { ProductId } from '../api/types';
import { AccessStateScreen } from './AccessState';

export function RequireProductAccess({
  product,
  children
}: {
  product: ProductId;
  children: ReactNode;
}): JSX.Element | null {
  const me = useMe();

  if (me.isLoading) {
    return null;
  }

  if (me.error) {
    throw me.error;
  }

  const state = me.data?.products[product] ?? 'not_owned';
  if (!grantsContent(state)) {
    return <AccessStateScreen state={state} />;
  }

  return <>{children}</>;
}
